import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createSoilSightProject } from "services";

import { useIsAuthenticated } from "utils";

import { CREATE_SOIL_SIGHT_PROJECT, GET_SOIL_SIGHT_PROJECT, LIST_SOIL_SIGHT_PROJECTS } from "consts";

import { CreateSoilSightProjectBody } from "models";

export const useCreateSoilSightProject = () => {
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [CREATE_SOIL_SIGHT_PROJECT],
    mutationFn: (body: CreateSoilSightProjectBody) => {
      if (!isAuthenticated) return Promise.reject(new Error("Not Authorized"));
      return createSoilSightProject(body);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [GET_SOIL_SIGHT_PROJECT, data?.soilSightProjectId] });
      queryClient.invalidateQueries({ queryKey: [LIST_SOIL_SIGHT_PROJECTS, variables.farmId] });
    },
  });
};
